import { addIntersectionItem } from '../../02-tools'
import anime from 'animejs'

export function StatRing() {
    const Els = document.querySelectorAll('.js-stat-ring')

    Array.from(Els).forEach((el) => {
        addIntersectionItem(el, intersects)
    })
}

function intersects({ el }, entry) {
    if (!entry.isIntersecting) {
        return
    }

    let value = el.dataset.value
    value = 1 - value / 100
    const line = el.querySelector('.js-stat-ring-line')
    const dashoffset = anime.setDashoffset(line)
    const endDashoffset = dashoffset * value

    anime({
        targets: line,
        strokeDashoffset: [dashoffset, endDashoffset],
        easing: 'cubicBezier(0.3, 0.15, 0.18, 1)',
        duration: 750,
        autoplay: true
    })
}
